var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.area && _vm.area.id && _vm.area.name)?_c('span',[_vm._v(" "+_vm._s(_vm.area.name)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }